<template>
  <tr
    data-sb-regression="sb-table-expandable-base-row"
    :class="[
      'expandable-rows-table-row',
      row?.depth > 0 ? `expandable-rows-table-sub-row subrow-depth-${row.depth}` : '',
      row.getIsSelected() ? 'row-selected' : '',
    ]"
  >
    <td
      v-for="(cell, index) in row.getVisibleCells()"
      :key="cell.id"
      :class="['expandable-rows-cell', cell.column.columnDef?.class?.cell ?? '']"
      :style="{ width: cell.column.getSize() + 'px' }"
    >
      <span :class="[cell.column?.columnDef.index === 0 ? `first-column-cell-container ${getSubRowClass(row)}` : '']">
        <ExpandCollapseRowCell
          v-if="index === 0"
          :row="row"
          :table-can-expand="tableCanExpand"
          :subrow-can-expand="subrowCanExpand"
          :disabled="isDisabled"
          :enable-row-selection="enableRowSelection"
          :sub-rows-table-selectable="subRowsTableSelectable && subrowColumnDefinitions != null"
          @row-selection-updated="onRowSelected"
        />
        <component
          :is="cell.column?.columnDef.cell"
          v-bind="rowEvents"
          v-if="cell.column?.columnDef?.isSFC"
          :cell="cell"
          :table="cell.getContext().table"
          :row="row"
          :column="cell.getContext().column"
          :get-value="cell.getContext().getValue"
          :value="cell.getContext().getValue()"
        />
        <FlexRender
          v-else
          v-bind="rowEvents"
          :render="cell.column?.columnDef?.cell"
          :props="cell.getContext()"
        />
      </span>
    </td>
  </tr>
</template>
<script>
import { FlexRender } from '@tanstack/vue-table';
import ExpandCollapseRowCell from '@src/components/Table/components/SbTableExpandableRows/components/ExpandCollapseRowCell.vue';

export default {
  name: 'SbTableExpandableBaseRow',
  components: {
    FlexRender,
    ExpandCollapseRowCell,
  },
  props: {
    table: {
      type: Object,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    enableRowSelection: {
      type: Boolean,
      required: true,
    },
    tableCanExpand: {
      type: Boolean,
      default: null,
    },
    subrowCanExpand: {
      type: Boolean,
      default: null,
    },
    columnDefinitions: {
      type: Array,
      required: true,
    },
    rowEvents: {
      type: Object,
      required: true,
    },
    subRowsTableSelectable: {
      type: Boolean,
      default: null,
    },
    subrowColumnDefinitions: {
      type: Array,
      required: false,
      default: () => null,
    },
    onRowSelected: {
      type: Function,
      required: true,
    },
  },
  computed: {
    isDisabled() {
      if (typeof this.enableRowSelection === 'function') return !this.enableRowSelection(this.row);
      return false;
    },
  },
  methods: {
    getSubRowClass(row) {
      if (row.getCanExpand()) {
        return `sub-row-can-be-expanded-level-${row?.depth}`;
      }

      return `sub-row-level-${row?.depth}`;
    },
  },
};
</script>
